<div class="home-content">
	<!-- Central container -->
	<main class="central-container">

		<destacado></destacado>

		<div class="dynamic-content">
			<salutacion></salutacion>
			<!-- <contenido></contenido> -->
		</div>

		<self-service class="static-content d-block d-lg-none"></self-service>

		<div class="dynamic-content">
			<humand-banner></humand-banner>
			<comunidad></comunidad>
			<!-- <beneficio></beneficio> -->
			<!-- <interes></interes> -->
			<recursos></recursos>
		</div>

	</main>

	<!-- Right container -->
	<aside class="right-container">
		<info></info>
	</aside>

</div>